"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

require("core-js/modules/es.array.reduce.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTagProps = exports.withFBGSuggestions = exports.withFilterByGroupContext = exports.useFilterByGroupContext = exports.FilterByGroupContext = void 0;
/* eslint-disable react/jsx-indent */

var react_1 = __importStar(require("react"));

var uuid_1 = require("uuid");

var lodash_1 = require("lodash");

var FilterByGroupContext = react_1.createContext({
  getSuggestions: function getSuggestions() {
    return [];
  },
  useRegisterSuggestions: function useRegisterSuggestions() {
    return function () {
      return undefined;
    };
  },
  setSelectedTag: function setSelectedTag() {
    return undefined;
  },
  setSelectedNode: function setSelectedNode() {
    return undefined;
  }
});
exports.FilterByGroupContext = FilterByGroupContext;

var useFilterByGroupContext = function useFilterByGroupContext() {
  return react_1.useContext(FilterByGroupContext);
};

exports.useFilterByGroupContext = useFilterByGroupContext;

var FilterByGroupProvider = function FilterByGroupProvider(_a) {
  var children = _a.children,
      suggestions = _a.suggestions;

  var _b = react_1.useState(),
      selectedTag = _b[0],
      setSelectedTag = _b[1];

  var _c = react_1.useState(),
      selectedNode = _c[0],
      setSelectedNode = _c[1];

  var refs = react_1.useRef([]);

  var getSuggestions = function getSuggestions() {
    var allSuggestions = refs.current.reduce(function (acc, ref) {
      return __spreadArrays(acc, ref.current.tags);
    }, suggestions || []);
    return lodash_1.uniqBy(allSuggestions, 'id').sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
  };

  var useRegisterSuggestions = function useRegisterSuggestions() {
    var newRef = react_1.useRef({
      id: uuid_1.v1(),
      tags: []
    });

    if (!refs.current.find(function (ref) {
      return ref.current.id === newRef.current.id;
    })) {
      refs.current.push(newRef);
    }

    return function (tags) {
      newRef.current.tags = __spreadArrays(tags);
    };
  };

  var newValue = {
    getSuggestions: getSuggestions,
    useRegisterSuggestions: useRegisterSuggestions,
    selectedTag: selectedTag,
    selectedNode: selectedNode,
    setSelectedTag: setSelectedTag,
    setSelectedNode: setSelectedNode
  };
  return react_1.default.createElement(FilterByGroupContext.Provider, {
    value: newValue
  }, children);
};

var withFilterByGroupContext = function withFilterByGroupContext(Component) {
  return function (props) {
    return (// eslint-disable-next-line react/destructuring-assignment
      react_1.default.createElement(FilterByGroupProvider, {
        suggestions: props.suggestions
      }, react_1.default.createElement(Component, __assign({}, props)))
    );
  };
};

exports.withFilterByGroupContext = withFilterByGroupContext;

var withTagProps = function withTagProps(suggestionOptions) {
  return function (Component) {
    return function (props) {
      var _a = useFilterByGroupContext(),
          getSuggestions = _a.getSuggestions,
          selectedTag = _a.selectedTag,
          useRegisterSuggestions = _a.useRegisterSuggestions;

      var registerSuggestions = useRegisterSuggestions();
      var defaultProps = {
        getSuggestions: getSuggestions,
        registerSuggestions: registerSuggestions,
        selectedTags: selectedTag ? [selectedTag] : []
      };
      var suggestionProps = Object.assign(defaultProps, suggestionOptions);
      return react_1.default.createElement(Component, __assign({}, props, suggestionProps));
    };
  };
};

exports.withTagProps = withTagProps;

var withFBGSuggestions = function withFBGSuggestions(_a) {
  var suggestions = _a.suggestions;
  return function (Component) {
    return function (props) {
      return react_1.default.createElement(Component, __assign({}, props, {
        suggestions: suggestions
      }));
    };
  };
};

exports.withFBGSuggestions = withFBGSuggestions;
exports.default = FilterByGroupContext;